
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/agro/activities",
      function () {
        return require("private-next-pages/agro/activities/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/agro/activities"])
      });
    }
  